export const PERMISSION_TEAM_EDIT                       = 1 << 0;
export const PERMISSION_TEAM_DELETE                     = 1 << 1;
export const PERMISSION_TEAM_ADD_CALENDAR               = 1 << 2;
export const PERMISSION_TEAM_ADD_MEMBER                 = 1 << 3;
export const PERMISSION_TEAM_MANAGE_EVENTS              = PERMISSION_TEAM_EDIT;
export const PERMISSION_TEAM_MANAGE_CATEGORIES          = PERMISSION_TEAM_EDIT;

export const PERMISSION_CALENDAR_EDIT                   = 1 << 0;
export const PERMISSION_CALENDAR_DELETE                 = 1 << 1;
export const PERMISSION_CALENDAR_MANAGE_EVENTS          = PERMISSION_CALENDAR_EDIT;

export function hasPermission(permissions, permission) {
    return (permissions & permission) === permission;
}



// WEBPACK FOOTER //
// ./src/application/util/permission.util.js